
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/worklist",
      function () {
        return require("private-next-pages/worklist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/worklist"])
      });
    }
  